import { Link } from "react-router-dom";
import DW from "../utils/images/LogoVoid.png";
import Facebook from "../utils/icons/Facebook.svg";
import Linkedin from "../utils/icons/Linkedin.svg";
import Instagram from "../utils/icons/Instagram.svg";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#7A1B29] border-t border-white/10">
      {/* Footer unificado con la paleta Borgoña de la inmobiliaria */}
      <div className="mx-[5vw] pt-6 md:pt-8">
        <div className="md:flex md:items-center md:justify-between xl:mx-[4.5vw]">
          <div className="md:w-[40vw]">
            <Link to="/" aria-label="Volver al inicio">
              <img
                className="my-6 drop-shadow-md"
                src={DW}
                alt="Logotipo DWilliams Bienes Raíces"
                style={{ maxWidth: "60px" }}
              />
            </Link>
            <p className="text-white/90 font-dmSans md:text-lg">
              Tu confianza es nuestra prioridad en cada paso del camino
              inmobiliario
            </p>
            <div className="flex items-center my-5 space-x-4">
              <a
                href="https://www.facebook.com/dwilliamsbr"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visitar nuestro perfil de Facebook"
              >
                <div className="border border-white/30 hover:bg-white/10 transition-colors shadow-button rounded-full flex w-[1.875rem] h-[1.875rem] justify-center items-center sm:w-[2.25rem] sm:h-[2.25rem]">
                  <img
                    className="w-[0.875rem] h-[1.25rem] sm:w-[1rem] sm:h-[1.375rem]"
                    src={Facebook}
                    alt=""
                    aria-hidden="true"
                  />
                </div>
              </a>
              <a
                href="https://www.linkedin.com/company/86424565/admin/feed/posts/?feedType=following"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visitar nuestro perfil de LinkedIn"
              >
                <div className="border border-white/30 hover:bg-white/10 transition-colors shadow-button rounded-full flex w-[1.875rem] h-[1.875rem] justify-center items-center sm:w-[2.25rem] sm:h-[2.25rem]">
                  <img
                    className="w-[0.875rem] h-[1.25rem] sm:w-[1rem] sm:h-[1.375rem]"
                    src={Linkedin}
                    alt=""
                    aria-hidden="true"
                  />
                </div>
              </a>
              <a
                href="https://www.instagram.com/dwilliamsbienesraices/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visitar nuestro perfil de Instagram"
              >
                <div className="border border-white/30 hover:bg-white/10 transition-colors shadow-button rounded-full flex w-[1.875rem] h-[1.875rem] justify-center items-center sm:w-[2.25rem] sm:h-[2.25rem]">
                  <img
                    className="w-[0.875rem] h-[1.25rem] sm:w-[1rem] sm:h-[1.375rem]"
                    src={Instagram}
                    alt=""
                    aria-hidden="true"
                  />
                </div>
              </a>
            </div>
          </div>
          <div className="min-[480px]:flex min-[480px]:space-x-32 md:space-x-24">
            <div className="my-8 font-semibold font-dmSans">
              <h2 className="mb-4 text-lg md:text-xl text-white">Páginas</h2>
              <ul className="flex flex-col text-white/80 items-start space-y-2 font-medium text-md sm:mb-0">
                <li>
                  <Link to="/" className="hover:text-white hover:underline transition-colors">
                    Inicio
                  </Link>
                </li>
                <li>
                  <Link to="/properties" className="hover:text-white hover:underline transition-colors">
                    Propiedades
                  </Link>
                </li>
                <li>
                  <Link to="/sale" className="hover:text-white hover:underline transition-colors">
                    En Venta
                  </Link>
                </li>
                <li>
                  <Link to="/rent" className="hover:text-white hover:underline transition-colors">
                    Alquileres
                  </Link>
                </li>
              </ul>
            </div>
            <div className="my-8 font-semibold font-dmSans">
              <h2 className="mb-4 text-lg md:text-xl text-white">Legal</h2>
              <ul className="flex flex-col items-start text-white/80 space-y-2 font-medium text-md sm:mb-0">
                <li>
                  <Link to="/terminos-y-condiciones" className="hover:text-white hover:underline transition-colors">
                    Términos y Condiciones
                  </Link>
                </li>
                <li>
                  <Link to="/politica-de-privacidad" className="hover:text-white hover:underline transition-colors">
                    Política de Privacidad
                  </Link>
                </li>
                <li>
                  <a href="/#contacto" className="hover:text-white hover:underline transition-colors">
                    Contacto
                  </a>
                </li>
                <li>
                  <Link to="/login" className="hover:text-white hover:underline text-white/50 transition-colors">
                    Acceso Administrativo
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="my-6 border-white/20 sm:mx-auto lg:my-0 lg:mt-8" />
        <span className="block my-5 text-sm text-center text-white/60">
          © {year} D' Williams. Todos los derechos reservados.
        </span>
      </div>
    </footer>
  );
};

export default Footer;